import styled from "@emotion/styled";

import { Image } from "./media";

export const EventTitle = styled.div`
label: event-title;
  display: flex;
  flex-direction: row;
  gap: 2px;
  justify-content: start;
  font-weight: 500;
  flex-wrap: ${(props) => props.wrap || ""};
  width: ${(props) => props.width || "100%"};
  ${({ alert, theme }) =>
    alert === "expired"
      ? `color: ${theme.palette.error.main};`
      : alert === "soon"
      ? "color: #cf6800;"
      : ""};

  @media (min-width: 800px) {
    justify-content: flex-start;
    width: auto;
  }
`;

export const PetNameEvent = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const EventType = styled.li`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, selected }) =>
    selected ? theme.custom.greenLight : theme.custom.white};
  font-size: ${(props) => props.fontSize || "14px"};
  font-weight: 500;
  gap: 5px;
  width: ${(props) => props.width || "45%"};
  cursor: pointer;
  height: auto;
  align-items: center;
  justify-content: center;
  padding: 10px;
  text-align: center;
  border-radius: 20px;
  border: ${({ theme, selected }) =>
    selected
      ? `2px solid ${theme.palette.primary.main}`
      : `1px solid ${theme.custom.grayInputs}`};
`;

export const SelectButton = styled.button`
  label: select-button;
  width: ${(props) => props.width || "auto"};
  padding: ${(props) => props.padding || "6px 20px"};
  border-radius: 8px;
  border: 1px solid
    ${({ theme, upcoming }) =>
      upcoming ? theme.palette.primary.main : theme.custom.grayInputs};
  background-color: ${({ theme }) => theme.custom.white};
  color: ${({ theme, upcoming }) =>
    upcoming ? theme.palette.primary.main : theme.palette.text.primary};
  font-size: 14px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.palette.background.lightGray};
    color: ${({ theme }) => theme.custom.grayInputs};
    border-color: ${({ theme }) => theme.custom.grayInputs};
    opacity: 0.7;
  }
`;

export const SelectDropdown = styled.div`
  label: select-dropdown;
  width: ${(props) => props.width || "100px"};
  position: absolute;
  top: ${(props) => props.top || "0"};
  left: 0;
  background-color: ${({ theme }) => theme.custom.white};
  border: 1px solid ${({ theme }) => theme.custom.grayInputs};
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const SelectOption = styled.div`
  label: select-option;
  padding: 5px 12px;
  background-color: ${({ theme }) => theme.custom.white};
  cursor: pointer;
  display: flex;
  width: 85%;
  border-bottom: 1px solid ${({ theme }) => theme.custom.grayInputs};
  justify-content: ${(props) => props.justify || "center"};
  gap: 5px;
  align-items: ${(props) => props.align || "center"};
`;

export const SelectArrowIcon = styled(Image)`
  right: 15px;
  pointer-events: none;
  font-size: 18px;
  color: #999;
`;

/** Сетка узких карточек выбора типа события (2 колонки, как в мобильном приложении) */
export const EventTypeChipsGrid = styled.ul`
  label: event-type-chips-grid;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
`;

/** Одна карточка: иконка слева, подпись справа */
export const EventTypeChipRow = styled.li`
  label: event-type-chip-row;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid
    ${({ theme, selected }) =>
      selected ? theme.palette.primary.main : theme.custom.grayInputs};
  background-color: ${({ theme }) => theme.custom.white};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  min-height: 48px;
  box-sizing: border-box;
`;

/** Заголовок категории над группой типов */
export const EventTypeSectionTitle = styled.p`
  label: event-type-section-title;
  margin: 12px 0 8px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};

  &:first-of-type {
    margin-top: 0;
  }
`;

export const FilterChip = styled.span`
  label: filter-chip;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: ${({ isSelected }) => (isSelected ? "600" : "400")};
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.palette.primary.main : "#f5f5f5"};
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.custom.white : theme.palette.text.primary};
  cursor: pointer;
  transition: all 0.2s ease;
  border: ${({ isSelected, theme }) =>
    isSelected ? "none" : `1px solid ${theme.custom.grayInputs}`};
  white-space: nowrap;

  &:hover {
    background-color: ${({ isSelected, theme }) =>
      isSelected ? theme.palette.primary.main : "#e8f5e9"};
  }
`;


